/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const uploadPhonePromptAssetParamsOwnerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const UploadPhonePromptAssetParams = zod.object({
  ownerType: zod.enum(['team', 'customer']),
  ownerId: zod.uuid().regex(uploadPhonePromptAssetParamsOwnerIdRegExp),
  slot: zod.enum(['inboundGreeting', 'clientCodePrompt', 'beforeTransfer', 'voicemailPrompt']),
});

export type UploadPhonePromptAssetParams = zod.input<typeof UploadPhonePromptAssetParams>;
export type UploadPhonePromptAssetParamsOutput = zod.output<typeof UploadPhonePromptAssetParams>;
